export interface City {
  city: string
  /** District name */
  region: string
  country: string
  lat: number
  lon: number
}

/** All 30 districts of Odisha with their capitals and major towns. */
export const CITIES: City[] = [
  // ── All 30 Districts of Odisha (District Capitals) ────────────────────
  { city: 'Angul', region: 'Angul', country: 'India', lat: 20.8416, lon: 85.1016 },
  { city: 'Balangir', region: 'Balangir', country: 'India', lat: 20.7038, lon: 83.479 },
  { city: 'Balasore', region: 'Balasore', country: 'India', lat: 21.4942, lon: 86.9335 },
  { city: 'Bargarh', region: 'Bargarh', country: 'India', lat: 21.3327, lon: 83.6178 },
  { city: 'Bhadrak', region: 'Bhadrak', country: 'India', lat: 21.0579, lon: 86.4982 },
  { city: 'Boudh', region: 'Boudh', country: 'India', lat: 20.8412, lon: 84.3241 },
  { city: 'Cuttack', region: 'Cuttack', country: 'India', lat: 20.4625, lon: 85.8828 },
  { city: 'Deogarh', region: 'Deogarh', country: 'India', lat: 21.5378, lon: 84.7362 },
  { city: 'Dhenkanal', region: 'Dhenkanal', country: 'India', lat: 20.6531, lon: 85.5978 },
  { city: 'Gajapati', region: 'Gajapati', country: 'India', lat: 18.7786, lon: 84.0946 },
  { city: 'Ganjam', region: 'Ganjam', country: 'India', lat: 19.3876, lon: 84.9994 },
  { city: 'Jagatsinghpur', region: 'Jagatsinghpur', country: 'India', lat: 20.2607, lon: 86.1729 },
  { city: 'Jajpur', region: 'Jajpur', country: 'India', lat: 20.8473, lon: 86.0055 },
  { city: 'Kalahandi', region: 'Kalahandi', country: 'India', lat: 19.9074, lon: 83.1669 },
  { city: 'Kandhamal', region: 'Kandhamal', country: 'India', lat: 20.4825, lon: 84.2308 },
  { city: 'Keonjhar', region: 'Keonjhar', country: 'India', lat: 21.6293, lon: 85.5801 },
  { city: 'Kendrapara', region: 'Kendrapara', country: 'India', lat: 20.5044, lon: 86.4194 },
  { city: 'Khordha', region: 'Khordha', country: 'India', lat: 20.1822, lon: 85.6118 },
  { city: 'Koraput', region: 'Koraput', country: 'India', lat: 18.8135, lon: 82.7101 },
  { city: 'Malkangiri', region: 'Malkangiri', country: 'India', lat: 18.3494, lon: 81.8873 },
  { city: 'Mayurbhanj', region: 'Mayurbhanj', country: 'India', lat: 21.9313, lon: 86.7285 },
  { city: 'Nabarangpur', region: 'Nabarangpur', country: 'India', lat: 19.2307, lon: 82.5414 },
  { city: 'Nayagarh', region: 'Nayagarh', country: 'India', lat: 20.1283, lon: 85.0961 },
  { city: 'Nuapada', region: 'Nuapada', country: 'India', lat: 20.7862, lon: 82.5418 },
  { city: 'Puri', region: 'Puri', country: 'India', lat: 19.8135, lon: 85.8312 },
  { city: 'Rayagada', region: 'Rayagada', country: 'India', lat: 19.172, lon: 83.4158 },
  { city: 'Sambalpur', region: 'Sambalpur', country: 'India', lat: 21.4669, lon: 83.9756 },
  { city: 'Subarnapur', region: 'Subarnapur', country: 'India', lat: 20.8314, lon: 83.9128 },
  { city: 'Sundargarh', region: 'Sundargarh', country: 'India', lat: 22.2604, lon: 84.8536 },
  { city: 'Jharsuguda', region: 'Jharsuguda', country: 'India', lat: 21.8614, lon: 84.0065 },

  // ── Major cities (Additional towns in various districts) ──────────────
  { city: 'Bhubaneswar', region: 'Khordha', country: 'India', lat: 20.2961, lon: 85.8245 },
  { city: 'Rourkela', region: 'Sundargarh', country: 'India', lat: 22.2604, lon: 84.8536 },
  { city: 'Berhampur', region: 'Ganjam', country: 'India', lat: 19.3149, lon: 84.7941 },
  { city: 'Baripada', region: 'Mayurbhanj', country: 'India', lat: 21.9313, lon: 86.7285 },
  { city: 'Bhawanipatna', region: 'Kalahandi', country: 'India', lat: 19.9074, lon: 83.1669 },
  { city: 'Chatrapur', region: 'Ganjam', country: 'India', lat: 19.3876, lon: 84.9994 },
  { city: 'Jeypur', region: 'Koraput', country: 'India', lat: 18.8516, lon: 82.5714 },
  { city: 'Kesinga', region: 'Kalahandi', country: 'India', lat: 20.1896, lon: 83.2238 },
  { city: 'Phulbani', region: 'Kandhamal', country: 'India', lat: 20.4825, lon: 84.2308 },
  { city: 'Paralakhemundi', region: 'Gajapati', country: 'India', lat: 18.7786, lon: 84.0946 },
  { city: 'Hirakud', region: 'Sambalpur', country: 'India', lat: 21.5214, lon: 83.8721 },
  { city: 'Paradip', region: 'Jagatsinghpur', country: 'India', lat: 20.3164, lon: 86.6116 },
  { city: 'Talcher', region: 'Angul', country: 'India', lat: 20.9551, lon: 85.2298 },
  { city: 'Balugaon', region: 'Khordha', country: 'India', lat: 19.775, lon: 85.043 },
  { city: 'Pipili', region: 'Puri', country: 'India', lat: 20.1178, lon: 85.7018 },
  { city: 'Nimapara', region: 'Puri', country: 'India', lat: 20.0564, lon: 86.022 },
  { city: 'Choudwar', region: 'Cuttack', country: 'India', lat: 20.5008, lon: 85.8411 },
  { city: 'Bhuban', region: 'Dhenkanal', country: 'India', lat: 20.8786, lon: 85.827 },
  { city: 'Barbil', region: 'Keonjhar', country: 'India', lat: 22.1028, lon: 85.3814 },
  { city: 'Kendujhar', region: 'Keonjhar', country: 'India', lat: 21.6293, lon: 85.5801 },
  { city: 'Chandbali', region: 'Bhadrak', country: 'India', lat: 20.7757, lon: 86.7352 },
  { city: 'Soro', region: 'Balasore', country: 'India', lat: 21.2379, lon: 86.6828 },
  { city: 'Udala', region: 'Mayurbhanj', country: 'India', lat: 21.5717, lon: 86.5731 },
  { city: 'Bonai', region: 'Sundargarh', country: 'India', lat: 21.9928, lon: 84.9404 },
  { city: 'Rajgangpur', region: 'Sundargarh', country: 'India', lat: 22.1936, lon: 84.599 },
  { city: 'Brajrajnagar', region: 'Jharsuguda', country: 'India', lat: 21.8205, lon: 83.919 },
  { city: 'Titlagarh', region: 'Balangir', country: 'India', lat: 20.2882, lon: 83.154 },
  { city: 'Deogarh Town', region: 'Deogarh', country: 'India', lat: 21.5378, lon: 84.7362 },
  { city: 'Digapahandi', region: 'Ganjam', country: 'India', lat: 19.5583, lon: 84.6572 },
  { city: 'Brahmapur', region: 'Ganjam', country: 'India', lat: 19.3149, lon: 84.7941 },
]
